import { ChatIFrame } from "components/organisms/ChatIFrame";

const Chat = () => {
  return <ChatIFrame page="chat" />;
};

export { Chat };
